<section id="corr-add-document-container">
  <app-header [title]="computedTitle"></app-header>
  <!-- Add New Documnent -->
  <div class="container">
    <section class="info-box">
      <h1 class="info-box-heading">Documents</h1>
      <div class="info-box-wrapper">
        <div class="info-box-body">
          <form style="margin-bottom: 30px" #fileChooserForm>
            <input
              type="file"
              #fileInput
              id="file-input"
              (change)="fileChangeEvent($event)"
              multiple
              style="display: none;"
              [disabled]="disabled"
              />
              <label for="file-input" class="btn-label">Choose Files...</label>
            <!-- <button mat-raised-button (click)="fileInput.click()">
              Choose Files...
            </button> -->
          </form>
          <mat-list class="info-box-list flex-column">
            @for (doc of documents; track doc; let i = $index) {
              <mat-list-item>
                <div class="documents-preview">
                <mat-checkbox
                  checked="doc.selected"
                  (click)="toggleFile(i)"
                  [disabled]="disabled"></mat-checkbox>
                <i
                  class="fa fa-3x"
                  [class]="doc.iconRef"
                  aria-hidden="true"></i>
                <h2>{{ doc.name }} - {{ doc.size | prettySize }}</h2>
                <button
                  mat-raised-button
                  (click)="removeFileFromUpload(doc)"
                  [disabled]="disabled">
                  <mat-icon class="mat-icon-dark">remove</mat-icon>
                </button>
                </div>
              </mat-list-item>
            }
          </mat-list>
          @if (documents.length > 0) {
            <div
              style="margin-top: 30px"
              [class]="{
                color: size >= maxRequestLength ? '#f44336' : 'inherit',
              }">
              @if (size >= maxRequestLength) {
                <p style="color: #f44336; margin-bottom: 10px">
                  *must be less than {{ maxRequestLength | prettySize }}
                </p>
              }
              <p>Total size: {{ size | prettySize }}</p>
            </div>
          }
        </div>
        <div class="info-box-btn flex-row-end">
          <button
            mat-raised-button
            (click)="uploadFiles()"
            [disabled]="disabled">
            Upload Selected
          </button>
          <button
            mat-raised-button
            [routerLink]="['../..']"
            [disabled]="disabled">
            Cancel
          </button>
        </div>
        @if (disabled) {
          <div class="overlay-and-progress">
            <div class="bar-holder">
              <mat-progress-bar
                mode="determinate"
                [value]="percentComplete"></mat-progress-bar>
              <div class="progress-message">
                Upload {{ percentCompleteDisplay }} complete.
              </div>
            </div>
          </div>
        }
      </div>
    </section>
  </div>
</section>
